var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'mini-store';
import ColumnManager from './ColumnManager';
import { BodyTable } from './BodyTable';
import { HeadTable } from './HeadTable';
import Pagination from '../Pagination';
import ExpandableTable from './ExpandableTable';
import { DivTag } from '../../Utils/AtomicTag';
var LgTable = /** @class */ (function (_super) {
    __extends(LgTable, _super);
    function LgTable(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBodyScrollLeft = function (e) {
            var target = e.target;
            // if (e.currentTarget !== target) {
            //   return;
            // }
            var _a = _this.props.scroll, scroll = _a === void 0 ? {} : _a;
            var _b = _this, headTable = _b.headTable, bodyTable = _b.bodyTable;
            if (scroll.x) {
                if (target === bodyTable && headTable) {
                    headTable.scrollLeft = target.scrollLeft;
                }
                else if (target === headTable && bodyTable) {
                    bodyTable.scrollLeft = target.scrollLeft;
                }
            }
        };
        _this.handleBodyScrollTop = function (e) {
            var target = e.target;
            // if (e.currentTarget !== target) {
            //   return;
            // }
            var _a = _this.props.scroll, scroll = _a === void 0 ? {} : _a;
            var _b = _this, headTable = _b.headTable, bodyTable = _b.bodyTable, fixedColumnsBodyLeft = _b.fixedColumnsBodyLeft, fixedColumnsBodyRight = _b.fixedColumnsBodyRight;
            if (scroll.y && target !== headTable) {
                var scrollTop = target.scrollTop;
                if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
                    fixedColumnsBodyLeft.scrollTop = scrollTop;
                }
                if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
                    fixedColumnsBodyRight.scrollTop = scrollTop;
                }
                if (bodyTable && target !== bodyTable) {
                    bodyTable.scrollTop = scrollTop;
                }
            }
        };
        _this.handleBodyScroll = function (e) {
            _this.handleBodyScrollLeft(e);
            _this.handleBodyScrollTop(e);
        };
        _this.getRowKey = function (record, index) {
            var rowKey = _this.props.rowKey;
            var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
            return key === undefined ? index : key;
        };
        _this.saveRef = function (name) { return function (node) {
            _this[name] = node;
        }; };
        _this.handlePageChange = function (current) {
            var paginationState = _this.state.paginationState;
            var pagination = _this.props.pagination;
            if (typeof paginationState === 'boolean')
                return;
            _this.setState({
                paginationState: __assign(__assign({}, paginationState), { current: current }),
            });
            if (typeof pagination === 'object' && pagination.onChange) {
                pagination.onChange(current, null);
            }
        };
        _this.renderPagination = function () {
            var _a = _this.props, data = _a.data, pagination = _a.pagination;
            var total = data.length;
            var paginationState = _this.state.paginationState;
            if (pagination === false) {
                return null;
            }
            var paginationRest = {};
            if (typeof pagination === 'object') {
                paginationRest = __assign(__assign({}, pagination), (typeof paginationState === 'object' && paginationState));
            }
            var paginationClassName = 'my-px-10 ';
            if (typeof pagination === 'object' && pagination.className) {
                paginationClassName += pagination.className;
            }
            return (React.createElement(Pagination, __assign({}, paginationRest, { total: total, current: _this.getMaxCurrent(total), onChange: _this.handlePageChange, className: paginationClassName })));
        };
        _this.state = {
            paginationState: _this.getDefaultPagination(),
            columns: [],
        };
        _this.props.store.setState({
            paginationDataForChange: _this.getDefaultPagination(),
        });
        _this.columnManager = new ColumnManager(props.columns, props.children);
        return _this;
    }
    LgTable.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.columns && nextProps.columns !== prevState.columns) {
            return {
                columns: nextProps.columns,
                children: null,
            };
        }
        if (nextProps.children !== prevState.children) {
            return {
                columns: null,
                children: nextProps.children,
            };
        }
        return null;
    };
    LgTable.prototype.getDefaultPagination = function () {
        // @ts-ignore
        var pagination = typeof this.props.pagination === 'object' ? this.props.pagination : {};
        var current;
        if ('current' in pagination) {
            current = pagination.current;
        }
        else if ('defaultCurrent' in pagination) {
            // @ts-ignore
            current = pagination.defaultCurrent;
        }
        var pageSize;
        if ('pageSize' in pagination) {
            pageSize = pagination.pageSize;
        }
        else if ('defaultPageSize' in pagination) {
            // @ts-ignore
            pageSize = pagination.defaultPageSize;
        }
        return {
            current: current || 1,
            pageSize: pageSize || 10,
        };
    };
    LgTable.prototype.getChildContext = function () {
        return {
            table: {
                props: this.props,
                saveRef: this.saveRef,
                columnManager: this.columnManager,
            },
        };
    };
    LgTable.prototype.syncFixedTableRowHeight = function () {
        var headRows = this.bodyTable.querySelectorAll('thead');
        var bodyRows = this.bodyTable.querySelectorAll('[class*="table-row"]') || [];
        var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) { return row.getBoundingClientRect().height || 'auto'; });
        var fixedColumnsBodyRowsHeight = [].reduce.call(bodyRows, function (acc, row) {
            var rowKey = row.getAttribute('data-row-key');
            var height = row.clientHeight || 'auto';
            acc[rowKey] = height;
            return acc;
        }, {});
        this.props.store.setState({
            fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
            fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight,
        });
    };
    LgTable.prototype.componentDidMount = function () {
        this.syncFixedTableRowHeight();
    };
    LgTable.prototype.renderBodyTable = function (options) {
        var currentPageData = this.getCurrentPageData();
        var columns = [];
        if (options.fixed === 'left') {
            columns = this.columnManager.leftColumns();
        }
        else if (options.fixed === 'right') {
            columns = this.columnManager.rightColumns();
        }
        else {
            columns = this.columnManager.groupedColumns();
        }
        var bodyTable = (React.createElement(BodyTable, { columns: columns, expander: this.expander, data: currentPageData, getRowKey: this.getRowKey, handleBodyScroll: this.handleBodyScroll, fixed: options.fixed }));
        return bodyTable;
    };
    LgTable.prototype.renderHeadTable = function (options) {
        var currentPageData = this.getCurrentPageData();
        var columns = [];
        if (options.fixed === 'left') {
            columns = this.columnManager.leftColumns();
        }
        else if (options.fixed === 'right') {
            columns = this.columnManager.rightColumns();
        }
        else {
            columns = this.columnManager.groupedColumns();
        }
        var headTable = (React.createElement(HeadTable, { columns: columns, data: currentPageData, handleBodyScrollLeft: this.handleBodyScrollLeft, fixed: options.fixed }));
        return headTable;
    };
    LgTable.prototype.isTableLayoutFixed = function () {
        var columns = this.props.columns;
        if (columns.some(function (_a) {
            var ellipsis = _a.ellipsis;
            return !!ellipsis;
        })) {
            return true;
        }
        return false;
    };
    LgTable.prototype.getCurrentPageData = function () {
        var _a = this.props, data = _a.data, pagination = _a.pagination;
        var current;
        var pageSize;
        var state = this.state;
        if (pagination === false) {
            current = 1;
            pageSize = Number.MAX_VALUE;
        }
        else {
            if (typeof state.paginationState === 'object') {
                pageSize = Number(state.paginationState.pageSize);
            }
            current = Number(this.getMaxCurrent(data.length));
        }
        if (data.length > pageSize) {
            data = data.filter(function (_, i) {
                return i >= (current - 1) * pageSize && i < current * pageSize;
            });
        }
        return data;
    };
    LgTable.prototype.getMaxCurrent = function (total) {
        if (typeof this.state.paginationState === 'boolean')
            return;
        var _a = this.state.paginationState, current = _a.current, pageSize = _a.pageSize;
        if ((current - 1) * pageSize >= total) {
            return Math.floor((total - 1) / pageSize) + 1;
        }
        return current;
    };
    LgTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, style = _a.style, footer = _a.footer, title = _a.title, columns = _a.columns, name = _a.name;
        if (this.state.columns) {
            this.columnManager.reset(columns);
        }
        var tableBoxClassName = "" + (className || '') + (this.isTableLayoutFixed() ? ' table-layout-fixed' : '');
        var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();
        var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
        var currentPageData = this.getCurrentPageData();
        return (React.createElement(ExpandableTable, __assign({}, this.props, { columnManager: this.columnManager }), function (expander) {
            _this.expander = expander;
            return (React.createElement(React.Fragment, null,
                React.createElement(DivTag, { name: name, className: tableBoxClassName, style: style },
                    title ? React.createElement("div", null, title(currentPageData)) : null,
                    React.createElement(DivTag, { autoPrefixedClassName: "main-table" },
                        _this.renderHeadTable({ fixed: '' }),
                        _this.renderBodyTable({ fixed: '' })),
                    hasRightFixed && (React.createElement(DivTag, { autoPrefixedClassName: "table-fixed-right" },
                        _this.renderHeadTable({ fixed: 'right' }),
                        _this.renderBodyTable({ fixed: 'right' }))),
                    hasLeftFixed && (React.createElement(DivTag, { autoPrefixedClassName: "table-fixed-left" },
                        _this.renderHeadTable({ fixed: 'left' }),
                        _this.renderBodyTable({ fixed: 'left' }))),
                    footer ? React.createElement("div", null, footer(currentPageData)) : null),
                _this.renderPagination()));
        }));
    };
    LgTable.childContextTypes = {
        table: PropTypes.any,
    };
    return LgTable;
}(Component));
export default connect(function () { })(LgTable);
